import { Component } from '@angular/core';
import { ISorteo } from 'src/app/interfaces/sorteos/index.interface';
import { SorteosService } from 'src/app/services/api/sorteos/sorteos.service';


@Component({
  selector: 'app-sorteos-historic',
  templateUrl: './sorteos-historic.component.html',
  styleUrls: ['./sorteos-historic.component.scss']
})

export class SorteosHistoricComponent {

  sorteos: ISorteo[] = [];
  sorteoHistoryActive: ISorteo[] = [];
  sorteoHistoryFinished: ISorteo[] = [];
  currentDate: Date;
  loading: boolean = true;
  showHistory: boolean = false;
  showWinners: boolean = false;
  openSorteos: { [key: string]: boolean } = {};

  constructor(
    private sorteosService: SorteosService,
  ) {
    this.currentDate = new Date();
  }

  ngOnInit(): void {
    this.getHistorySorteos();
  }

  getHistorySorteos() {
    this.sorteosService.getHistorySorteos()
      .subscribe(
        (data: any) => {
          this.loading = false;
          const now = new Date();

          const processSorteo = (sorteo: ISorteo) => ({
            ...sorteo,
            totalChance: this.calculateTotalChance(sorteo),
            formattedExpirationDate: this.formatDate(sorteo.expirationDate),
            listQuantityChance: sorteo.listQuantityChance?.map((chance: any) => ({
              ...chance,
              formattedDate: this.formatDate(chance.dateChance)
            })) || []
          });


          this.sorteoHistoryActive = data
          .filter((s: any) => new Date(parseInt(s.expirationDate)) > now)
          .map(processSorteo)
          .sort((a: any, b: any) => new Date(parseInt(a.expirationDate)).getTime() - new Date(parseInt(b.expirationDate)).getTime());

        this.sorteoHistoryFinished = data
          .filter((s: any) =>new Date(parseInt(s.expirationDate)) <= now)
          .map(processSorteo)
          .sort((a: any, b: any) => new Date(parseInt(b.expirationDate)).getTime() - new Date(parseInt(a.expirationDate)).getTime());

        },
        (error: any) => {
          console.error(error);
        }
      );
  }

  calculateTotalChance(sorteo: ISorteo): number {
    const totalChances = sorteo.listQuantityChance?.reduce(
      (sum: number, chance: any) => sum + (chance.quantityChance || 0), 
      0
    ) || 0;
    return totalChances;
  }

  private formatDate(timestamp: number): string {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return new Intl.DateTimeFormat('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  }

  getItemValue(item: any, property: string, index: number): string {
    const value = item[property];
    if (value) {
      const parts = value.split(/[;\/|]/);
      return parts[index] || '';
    }
    return '';
  }

  getFormattedWinners(description7: string): string {
    const winnersData = description7.split(';');
    const formattedWinners = winnersData.map(data => {
        const [name, dni] = data.split('|');
        return `${name} <small>(${dni})</small>`;
    });
    return formattedWinners.join(' | ');
  }

  toggleAccordion(sorteoCode: string) {
    this.openSorteos[sorteoCode] = !this.openSorteos[sorteoCode];
  }

  isSorteoOpen(sorteoCode: string): boolean {
    return !!this.openSorteos[sorteoCode];
  }

  toggleWinners(): void {
    this.showWinners = !this.showWinners;
  }
}
